import { Formik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FormDisplay from "./FormDisplay";
import pages from "../../../../constants/pages";
import { useAxios, useAlert } from "../../../../hooks";
import { objectFromFormData, validationSchema } from "./campaignObject";

export default function Form({
  agents,
  formData,
  editState,
  audiences,
  categories,
  setFormData,
  setEditState,
  audienceSize,
  audienceData,
  connectionList,
  setAudienceData,
  preferredChannels,
  setAudienceCreated,
}) {
  const axios = useAxios();
  const { alert } = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [agentToken, setAgentToken] = useState({});

  const { activeBrand } = useSelector((state) => state.memberDetails);

  return (
    <Formik
      enableReinitialize
      initialValues={formData}
      validationSchema={validationSchema}
      validateOnChange
      onSubmit={async (formData, { setSubmitting }) => {
        try {
          const url = formData.campaignID
            ? "/user/update/campaign/" + formData.campaignID
            : "/user/create/campaign";

          const method = formData.campaignID ? "PUT" : "POST";

          const res = await axios({
            url,
            method,
            disableRedirect: true,
            data: objectFromFormData(formData, activeBrand),
          });

          if (res.status) {
            if (audienceData.ID !== formData.audienceID) {
              const audienceRes = await axios({
                url: "/brand/getDetailsOfAudience/" + formData.audienceID,
              });

              if (audienceRes.status) {
                let data = {};

                for (let key of audienceRes.data.fields) {
                  data[Object.keys(key)[0]] = {
                    value: Object.values(key)[0],
                    mandatory: Object.values(key)[1],
                  };
                }

                data = {
                  ...data,
                  ID: audienceRes.data.audience_id,
                  brandID: audienceRes.data.brand_id,
                };

                await setAudienceData(data);
              }
            }

            if (formData.campaignID) {
              dispatch(
                alert({
                  message: "Campaign updated Successfully!",
                  type: "success",
                })
              );
              setEditState(false);
            } else {
              dispatch(
                alert({
                  message: "Campaign Created Successfully!",
                  type: "success",
                })
              );
              navigate(pages.campaignDetails.route + res.data.campaign_id);
            }

            setFormData((prev) => ({
              ...prev,
              campaignStatus: res.data?.status,
              campaign_status: res.data?.campaign_status,
            }));
          } else {
            console.error("API response status false", res);
          }
        } catch (err) {
          console.error(err);
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {(formikProps) => (
        <FormDisplay
          agentToken={agentToken}
          setAgentToken={setAgentToken}
          agents={agents}
          audienceSize={audienceSize}
          audiences={audiences}
          editState={editState}
          categories={categories}
          formikProps={formikProps}
          audienceData={audienceData}
          setEditState={setEditState}
          connectionList={connectionList}
          setAudienceData={setAudienceData}
          preferredChannels={preferredChannels}
          setAudienceCreated={setAudienceCreated}
        />
      )}
    </Formik>
  );
}
